import { render, staticRenderFns } from "./VisitSubmission.vue?vue&type=template&id=88a79054&scoped=true&"
import script from "./VisitSubmission.vue?vue&type=script&lang=js&"
export * from "./VisitSubmission.vue?vue&type=script&lang=js&"
import style0 from "./VisitSubmission.vue?vue&type=style&index=0&id=88a79054&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a79054",
  null
  
)

export default component.exports